import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { type EventScheduleItem } from "@/schemas/events/EventSchedule";

interface EventScheduleProps {
  schedule: EventScheduleItem[];
}

function EventSchedule({ schedule }: EventScheduleProps): React.JSX.Element {
  return (
    <View style={styles.container}>
      {schedule.map((event, index) => (
        <View key={index} style={styles.item}>
          <View style={styles.marker}>
            <View style={styles.dot} />
            {index !== schedule.length - 1 && <View style={styles.line} />}
          </View>
          <View style={styles.eventContent}>
            <View style={styles.timeContainer}>
              <Text style={styles.timeText}>{event.startDateTime}</Text>
              <Text style={styles.timeText}> - </Text>
              <Text style={styles.timeText}>{event.endDateTime}</Text>
            </View>
            <Text style={styles.eventTitle}>{event.title}</Text>
            <Text style={styles.eventDescription}>{event.description}</Text>
          </View>
        </View>
      ))}
    </View>
  );
}

export default EventSchedule;

export const styles = StyleSheet.create({
  container: {
    marginLeft: 30,
  },
  item: {
    flexDirection: "row",
    marginBottom: 24,
  },
  marker: {
    alignItems: "center",
    width: 20,
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#01579b",
    marginTop: 6,
  },
  line: {
    width: 2,
    height: "80%",
    backgroundColor: "#E5E7EB",
    position: "absolute",
    top: 16,
    left: 9,
  },
  eventContent: {
    flex: 1,
    marginLeft: 12,
  },
  timeContainer: {
    flexDirection: "row",
    marginBottom: 4,
  },
  timeText: {
    fontSize: 15,
    color: "#1F2937",
    fontWeight: "500",
  },
  eventTitle: {
    fontSize: 16,
    fontWeight: "500",
    color: "#374151",
    marginBottom: 2,
  },
  eventDescription: {
    fontSize: 14,
    color: "#4B5563",
  },
});
